<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Tipo de unidad {{ form.nombre }}</h3>
      </div>
      <div class="layout__controls">
        <button v-show="(permiteEditarTipoUnidad || permiteEliminarTipoUnidad)" @click="$modal.show('tiposUnidad')" class="btn-info btn--bigger"><i class="fa fa-search"></i> <span>Buscar</span></button>
        <modal name="tiposUnidad" height="auto" width="60%" scrollable>
          <lista-tipos-unidad @selected="selectedTipoUnidad" :editButton="false" :createButton="false" :deleteButton="false"></lista-tipos-unidad>
        </modal>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del tipo de unidad</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <input-field v-model="form.nombre" id="nombre" placeholder="Escriba un nombre...">
                    <span>Nombre</span>
                    <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
                      {{ errores.nombre[0] }}
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <input-field v-model="form.descripcion" id="descripcion" placeholder="Escriba una descripción...">
                  <span>Descripción</span>
                  <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
                    {{ errores.descripcion[0] }}
                  </span>
                </input-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button v-show="(permiteCrearTipoUnidad && estado === 'N') || (permiteEditarTipoUnidad && estado !== 'N')" @click="guardar" class="btn-success" type="button"><i class="fa fa-save"></i> <span>Guardar</span></button>
            <button v-show="permiteCrearTipoUnidad" @click="crearNuevo" class="btn-light btn--text" type="button"><i class="fa fa-plus"></i> <span>Nuevo</span></button>
            <button v-show="estado === 'A' && permiteEliminarTipoUnidad" @click="eliminar" type="button" class="btn-danger btn--text"><i class="fa fa-ban"></i> <span>Eliminar</span></button>
            <button v-show="estado === 'I' && permiteEliminarTipoUnidad" @click="eliminar" type="button" class="btn-dark btn--text"><i class="fa fa-power-off"></i> <span>Re-activar</span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props : {
        permiteCrearTipoUnidad : {
            type : Boolean,
            default : true,
            required : false
        },
        permiteEditarTipoUnidad : {
            type : Boolean,
            default : true,
            required : false
        },
        permiteEliminarTipoUnidad : {
            type : Boolean,
            default : true,
            required : false
        }
    },
    data : function () {
        return {
            form : {
                nombre : '',
                descripcion : '',
                _method : undefined
            },
            estado : 'N',
            errores : {
                nombre : undefined,
                descripcion : undefined
            },
            id : '',
            url : url
        };
    },
    methods : {
        crearNuevo : function () {
            let that = this;
            swal({
                title: '¿Desea crear un nuevo tipo de unidad?',
                text: "El formulario será reiniciado.",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : 'Crear nuevo',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        that.limpiarFormulario();
                        that.limpiarErrores();
                        that.estado = 'N';
                    }
            });
        },
        limpiarFormulario : function () {
            this.form = {
                nombre : '',
                descripcion : '',
                _method : undefined
            };
        },
        limpiarErrores : function () {
            this.errores = {
                nombre : undefined,
                descripcion : undefined
            };
        },
        guardar : function () {
            this.limpiarErrores();
            let that = this;
            let urlRequest = url + '/tipos-unidad';
            if (this.estado !== 'N')
            {
                this.form._method = 'PUT';
                urlRequest += '/' + this.id;
            }
            else 
                this.form._method = undefined;
            axios.post(urlRequest, this.form).then(function (response) {
                that.estado = response.data.estado;
                that.id = response.data.id;
                swal('El tipo de unidad fue almacenado exitósamente.', 'Realizado', 'success');
            }).catch(function (error) {
                if (error !== null && error !== undefined) {
                    let response = error.response;
                    if (response !== null && response !== undefined) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal('Hay errores en el formulario.', 'Aviso', 'warning');
                        }
                        else 
                            swal('Hubo un error al momento de guardar el formulario, intente nuevamente.', 'Error', 'error');
                    }
                }
            });
        },
        eliminar : function () {
            let that = this;
            swal({
                title: '¿Desea ' + (this.estado === 'A'?'eliminar':'re-activar') + ' el tipo de unidad?',
                text: "El tipo de unidad será " + (this.estado === 'A'?'eliminado':'re-activado') + ".",
                type: 'warning',
                showCancelButton: true,
                confirmButtonText : (this.estado === 'A'?'Eliminar':'Re-activar'),
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value)
                    {
                        axios.post(that.url + '/tipos-unidad/' + that.id, {
                            _method : 'DELETE'
                        }).then(function (response) {
                            that.estado = response.data.estado;
                            swal('El tipo de unidad ha sido ' + (that.estado === 'I'?'eliminado':'re-activado') + '.', 'Realizado', 'success');
                        });
                    }
            });
        },
        selectedTipoUnidad : function (tipoUnidad) {
            this.form.nombre = tipoUnidad.nombre;
            this.form.descripcion = tipoUnidad.descripcion;
            this.estado = tipoUnidad.estado;
            this.id = tipoUnidad.id;
            this.$modal.hide('tiposUnidad');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/tipos-unidad/TipoUnidad.vue